module.exports = __webpack_public_path__ + "aws.2b8e9a.svg";